import React from "react";
import Skeleton from "components/ui/Skeleton";
import { STATUS_META } from "../utils";

const RecipientStatusBreakdown = ({ data, loading }) => {
  const rows = (data || []).map((d) => {
    const meta = STATUS_META[d.status] || { label: d.status, color: "var(--color-text-muted)" };
    return { ...d, label: meta.label, color: meta.color };
  });
  const total = rows.reduce((sum, r) => sum + r.count, 0);

  return (
    <div className="rounded-2xl border border-border bg-surface p-5">
      <h2 className="font-semibold text-text_primary mb-4">Recipient Statuses</h2>

      {loading ? (
        <Skeleton.Rows rows={4} />
      ) : rows.length === 0 ? (
        <p className="text-sm text-text_muted py-10 text-center">No recipient activity in this period</p>
      ) : (
        <div className="space-y-2.5">
          {rows.map((r) => (
            <div key={r.status} className="flex items-center justify-between py-1.5 border-b border-border last:border-0">
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ backgroundColor: r.color }} />
                <span className="text-sm text-text_secondary">{r.label}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-text_primary tabular-nums">{r.count}</span>
                <span className="text-[11px] text-text_muted w-10 text-right">
                  {total > 0 ? Math.round((r.count / total) * 100) : 0}%
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecipientStatusBreakdown;
